import React from 'react';
import { RotateCcw } from 'lucide-react';
import { useGame } from '../context/GameContext';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from './ui/alert-dialog';

const ResetButton = () => {
  const { resetGame, gameState } = useGame();
  if (gameState === 'home') return null;

  return (
    <div className="fixed top-4 right-4 z-50">
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <button data-testid="reset-game-btn"
            className="btn-noir bg-[#141414] border border-[#222] text-[#5A5A5A] p-3 rounded-lg" aria-label="Reset">
            <RotateCcw size={16} />
          </button>
        </AlertDialogTrigger>
        <AlertDialogContent className="bg-[#141414] border-[#333] text-[#E0DDD5] rounded-xl">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-typewriter text-xl text-[#EF4444]">Close Case?</AlertDialogTitle>
            <AlertDialogDescription className="text-[#5A5A5A] font-mono text-sm">
              All evidence will be lost. This action cannot be undone.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="bg-[#1A1A1A] text-[#E0DDD5] hover:bg-[#222] border-[#333]">Cancel</AlertDialogCancel>
            <AlertDialogAction data-testid="confirm-reset-btn" onClick={resetGame}
              className="bg-[#DC2626] text-[#E0DDD5] hover:bg-[#E53E3E]">Close Case</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};

export default ResetButton;
